var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqdfy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1872_4880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7429,
    cy: 10.7502,
    r: 10.7429,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1872_4880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17596 4.63147C3.62228 4.63147 1.55212 2.56131 1.55212 0.0076309C1.55212 -2.54605 3.62228 -4.61621 6.17596 -4.61621C8.72964 -4.61621 10.7998 -2.54605 10.7998 0.0076313C10.7998 2.56131 8.72964 4.63147 6.17596 4.63147Z",
    fill: "#FC5FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5135 22.2974C19.5133 19.7438 17.4434 17.6738 14.89 17.6738C12.3367 17.6738 10.2668 19.7438 10.2666 22.2974L19.5135 22.2974Z",
    fill: "#A257FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90191 14.9844C9.90191 20.0917 5.76162 24.232 0.654323 24.232C-4.45298 24.232 -8.59326 20.0917 -8.59326 14.9844C-8.59326 9.8771 -4.45298 5.73682 0.654323 5.73682C5.76162 5.73682 9.90191 9.8771 9.90191 14.9844Z",
    fill: "#FFC759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4565 7.10642C11.4565 1.99912 15.5968 -2.14117 20.7041 -2.14117C25.8114 -2.14117 29.9517 1.99912 29.9517 7.10642C29.9517 12.2137 25.8114 16.354 20.7041 16.354C15.5968 16.354 11.4565 12.2137 11.4565 7.10642Z",
    fill: "#23EDF9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqdfy);
export default __webpack_public_path__ + "static/media/sqdfy.518c0d7a214b13f149cfd7446458b3b0.svg";
export { ForwardRef as ReactComponent };